import React from 'react';
import {EmergencyTelehealthJourney} from 'presentation/modules/booking/emergencyTelehealth/ui/pages/EmergencyTelehealthJourney';

export const MakeEmergencyTelehealthJourney = () => <EmergencyTelehealthJourney />;
